<style>
    .profile-image{
        height: 35px;
        width: 35px;
        object-fit: cover;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--text-white);
        border-radius: 50%;
        overflow: hidden;
    }
    .profile-image-bg{
        background-color: #383838;
    }
    html[data-theme="dark"] .profile-image-bg{
        background-color: var(--primary);
    }
</style>
<script>


    export default {
        props: ['user', 'height', 'width'],
        data: function () {
            return {
                
            };
        },
        created: function () {

        },
        mounted: function () {
            var self = this;
            
        },
        computed: {
            initials: function(){
                var initials = '';
                if(this.user.first_name){
                    initials += this.user.first_name[0];
                }
                if(this.user.last_name){
                    initials += this.user.last_name[0];
                }
                if(!initials){
                    initials = 'U';
                }
                return initials;
            },
            h: function(){
                var value = '35px';
                if(this.height){
                    value = this.height + '';
                    if(!value.includes('px')){
                        value += 'px';
                    }
                }
                return value;
            },
            w: function(){
                var value = '35px';
                if(this.width){
                    value = this.width + '';
                    if(!value.includes('px')){
                        value += 'px';
                    }
                }
                return value;
            },
            font_size: function(){
                var height = parseInt(this.h); 
                return Math.round(height/2) + 'px';
            },
            style: function(){
                var style = {
                    'height': this.h,
                    'width': this.w,
                    'font-size': this.font_size
                };
                return style;
            }
        },
        watch: {

        },
        methods: {
        
        },
        filters: {

        }
    };
</script>

<template>
    <div>
        <img class="profile-image rounded-circle" :src="user.profile_image_url" :style="style" v-if="user.profile_image_url">
        <div class="profile-image rounded-circle profile-image-bg" :style="style" v-else>{{initials}}</div>
    </div>
</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/misc/userImage.vue